import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import * as icons from '@gn-audio/icons';
import { ComponentProps, HexColor } from '@gn-audio/jss-components';
import { Family } from '@gn-audio/jss-core';

import { StandardPriceModel } from 'api/pricesApi/pricesModel';
import { SitecoreLookupId } from 'common/siteCoreHelpers';

type FamilyWithBuyPageUrl = Family & {
  buyPageUrl?: string;
};

export type CompareTablesSpotProps = {
  families: FamilyWithBuyPageUrl[];
  productColumns: {
    product: SitecoreLookupId;
    productRow: ProductRow[];
  }[];
  iconBackgroundColor: Field<string>;
} & ComponentProps;

export type CompareTableSpotRendering = {
  productColumns: ProductColumnFields[];
  productColumnsShared: ProductColumnFields[];
  iconBackgroundColor: Field<string>;
  iconBackgroundColorShared: Field<string>;
};

export type CompareTableProduct = {
  id: string;
  product: Field<string>;
  productShared: Field<string>;
  productRow: CompareTableProductRow[];
  productRowShared: CompareTableProductRow[];
};

export type CompareTableProductRow = {
  icon: Field<keyof typeof icons>;
  headling: Field<string>;
  value: Field<string>;
};

export type FamilyWithPriceAndCurrency = FamilyWithBuyPageUrl & {
  id: string;
  productRow: ProductRow[];
  price: StandardPriceModel | null;
};

export type CompareTableColumnProps = {
  familyWithPrice: FamilyWithPriceAndCurrency;
  iconBackgroundColor: HexColor;
  maxHeight: number;
  onHeightChange: (height: number) => void;
};

export type ProductRow = {
  id: string;
  icon?: Field<keyof typeof icons>;
  headline: Field<string>;
  value: Field<string>;
};

export type ProductColumnFields = {
  product: Field<string>;
  productShared: Field<string>;
  productRow: ProductRow[];
  productRowShared: ProductRow[];
};

export type CompareProduct = {
  id: string;
  displayName: string;
  fields: ProductColumnFields;
};
